<template>
    <basic-container>
      <div style="display: flex;">
        <div class="left" style="width: 300px;margin-right: 10px;">
         
  
          <div>
            <el-form :model="searchForm" ref="searchFormRef" label-width="0px">
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="" prop="nursinghomeId">
                  <el-select
                    v-model="searchForm.nursinghomeId"
                    style="width:100%"
                    placeholder="服务网点"
                    @change="nursinghomeIdChange"
                  >
                    <el-option
                      v-for="item in nursinghomeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              
              
            </el-row>
          </el-form>
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText">
          </el-input>
              <el-tree
              default-expand-all
            ref="treeRef"
            node-key="id"
            :data="cameraList"
            :props="treeAreaProps"
            :expand-on-click-node="false"
            :highlight-current="true"
            :filter-node-method="filterNode"
            @node-click="treeNodeClick"
          >
            <span slot-scope="{ node }" class="custom-tree-node">
              <template>
                {{ node.data.name }}
              </template>
            </span>
          </el-tree>
          </div>
        </div>
        <div class="right" :style="`height: ${bodyHeight - 130}px;flex:1;overflow: scroll;`">
          
          <div  :style="`height: ${bodyHeight - 170}px;`">
            <div class="liveBody">
                <div class="live" v-for="(item,index) in currentCameraUrlList" :key="index"> 
                    <player :videoUrl="item" fluent autoplay @screenshot="shot"
                            @destroy="destroy"/>
                </div>
            </div>
            <div class="right_bottom">
                <el-pagination
                    layout="prev, pager, next"
                    :page-size="9"
                    @current-change="handleCurrentChange"
                    :total="cameraUrlList.length">
                </el-pagination>
            </div>
            </div>
        </div>
      </div>
    </basic-container>
  </template>
  <script>


  import { mapGetters } from 'vuex';
  import { getNursinghomeList } from '../../api/public.js';
  import { getCameraList } from '@/api/nursingHome/security.js';
  import player from  "@/views/nursingHome/components/jessibuca.vue"
 
  export default {
    components: {player},
    data() {
      return {
        treeAreaProps: {
          label: 'name',
          value: 'id',
          children: 'children',
        },
        filterText:"",
        rowInfo: {},
        nursinghomeList:[],
        searchForm: {
          name:'',
          nursinghomeId: '',
          cameraId: '',
        },
        accumulateEnergyUseShowList: [],
        nowEnergyUsingDataShowList: [],
        projectList: [],
  
        loading: false,
        cameraUrlList:[],
        currentCameraUrlList:[],
        cameraList: [],
      };
    },
    created() {
      this.initData();
      console.log('-------');
    },
    watch: {
      filterText(val) {
        this.$refs.treeRef.filter(val);
      }
    },
    
    mounted() {
     
    },
   
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      searchClear(){
        this.searchForm.name=''
      },
      nursinghomeIdChange(){
        this.filterText =""
        this. cameraUrlList =[]
        this.currentCameraUrlList =[]
        this.initCameraTree()
      },
      searchRecord(){
       

      },
      initCameraTree() {
        
        getCameraList(this.searchForm).then((res1) => {
          this.cameraList =[]
          
            let obj ={
            name:'全部',
            children:res1.data,
            id:0,
          }
          this.cameraList.push(obj)
          this.$nextTick(() => {
          setTimeout(() => {
          if(this.cameraList.length>0){
            this.$refs.treeRef.setCurrentKey(this.cameraList[0].id);
            this.treeNodeClick(this.cameraList[0]);
          }
          });
         })
         
          
        });

      },
      handleCurrentChange(val){
        console.log("----",val)
        this.currentCameraUrlList =[]


        
        for(let i=(val-1)*9;i<val*9&&i<this.cameraUrlList.length;i++){
            this.currentCameraUrlList.push(this.cameraUrlList[i])
        }
        
      },
     initData(){
        getNursinghomeList().then((res) => {
          
          this.nursinghomeList = res.data;
          if (this.nursinghomeList.length > 0) {
            this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeList[0].id);
           
            this.initCameraTree();
          }
        });
     },
     
      treeNodeClick(data, node) {
       console.log(data)
       this. cameraUrlList =[]
        this.currentCameraUrlList =[]
       if(data.id==0){
        // this.cameraUrlList =[]
        data.children.forEach(item => {
           this. cameraUrlList.push(item.cameraUrl)
        });
        this.handleCurrentChange(1)
       }else{
        this. cameraUrlList.push(data.cameraUrl)
        this.handleCurrentChange(1)
       }
      },
      getData() {
       
      },
      initOption() {
        
      },
    },
  };
  </script>
  
  <style scoped>
  .cardStyle {
    border: 1px solid #000;
    padding: 10px 25px;
  }
  .dataClass {
    font-size: 15px;
  }
  .cardBody {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 20px;
  }
  .liveBody {
  display: grid;
  height: 100%;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  grid-template-rows: repeat(3, 1fr);
}
.live {
  border: 1px solid #000; /* 设置网格线条颜色 */
  height: 100%;
  width: 100%;
  background: #000;
  display: flex;
  align-items: center;
}
  </style>
  